"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateFullAdsetRequestToJSON = exports.CreateFullAdsetRequestFromJSONTyped = exports.CreateFullAdsetRequestFromJSON = exports.instanceOfCreateFullAdsetRequest = void 0;
var runtime_1 = require("../runtime");
var AdSetCreateRequest_1 = require("./AdSetCreateRequest");
var CreateFullAdRequest_1 = require("./CreateFullAdRequest");
/**
 * Check if a given object implements the CreateFullAdsetRequest interface.
 */
function instanceOfCreateFullAdsetRequest(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfCreateFullAdsetRequest = instanceOfCreateFullAdsetRequest;
function CreateFullAdsetRequestFromJSON(json) {
    return CreateFullAdsetRequestFromJSONTyped(json, false);
}
exports.CreateFullAdsetRequestFromJSON = CreateFullAdsetRequestFromJSON;
function CreateFullAdsetRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'createAdSetRequest': !(0, runtime_1.exists)(json, 'create_ad_set_request') ? undefined : (0, AdSetCreateRequest_1.AdSetCreateRequestFromJSON)(json['create_ad_set_request']),
        'hierarchyDraftId': !(0, runtime_1.exists)(json, 'hierarchy_draft_id') ? undefined : json['hierarchy_draft_id'],
        'ads': !(0, runtime_1.exists)(json, 'ads') ? undefined : (json['ads'].map(CreateFullAdRequest_1.CreateFullAdRequestFromJSON)),
    };
}
exports.CreateFullAdsetRequestFromJSONTyped = CreateFullAdsetRequestFromJSONTyped;
function CreateFullAdsetRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'create_ad_set_request': (0, AdSetCreateRequest_1.AdSetCreateRequestToJSON)(value.createAdSetRequest),
        'hierarchy_draft_id': value.hierarchyDraftId,
        'ads': value.ads === undefined ? undefined : (value.ads.map(CreateFullAdRequest_1.CreateFullAdRequestToJSON)),
    };
}
exports.CreateFullAdsetRequestToJSON = CreateFullAdsetRequestToJSON;
